import React from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import CommentIcon from '@mui/icons-material/Comment';
import ShareIcon from '@mui/icons-material/Share';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

// JSON import
import postData from '../postData.json';

const iconMap = {
  FavoriteBorderIcon: <FavoriteBorderIcon sx={{ fontSize: 25 }} />,
  CommentIcon: <CommentIcon sx={{ fontSize: 25 }} />,
  ShareIcon: <ShareIcon sx={{ fontSize: 25 }} />,
  BookmarkBorderIcon: <BookmarkBorderIcon sx={{ fontSize: 25 }} />
};

const Post = () => {
  return (
    <>
      {postData.posts.map((post, index) => (
        <div className='post' key={index}>
          {/* Post Info */}
          <div className='postInfo'>
            <img className='InfoImg' src={post.postInfo.profileImg} alt={post.postInfo.username} />
            <div className='postInfousername'>{post.postInfo.username}</div>
            <div className='timingInfo'>{post.postInfo.time}</div>
          </div>

          {/* Post Image */}
          <div className='postImg'>
            <img className='postImage' src={post.postImg} alt='post' />
          </div>

          {/* Icons */}
          <div className='iconsBlock'>
            <div className='leftIcon'>
              {post.icons.left.map((iconName, i) => (
                <span key={i}>{iconMap[iconName]}</span>
              ))}
            </div>
            <div className='rightIcon'>
              {post.icons.right.map((iconName, i) => (
                <span key={i}>{iconMap[iconName]}</span>
              ))}
            </div>
          </div>

          {/* Likes */}
          <div className='likeSection'>
            <div className='imagesLike'>
              {post.likes.images.map((img, i) => (
                <img key={i} className={`likeimg${i + 1}`} src={img} alt='like' />
              ))}
              <div className='noofLikes'>{post.likes.totalLikes} Likes</div>
            </div>
          </div>

          {/* Post About */}
          <div className='postAbout'>
            <div className='postAboutName'>{post.postAbout.name}</div>
          </div>

          {/* Info Comment */}
          <div className='InfoComment'>{post.InfoComment}</div>

          {/* Comments */}
          <div className='noofcomments'>View all {post.noOfComments} comments</div>
          <div className='addComments'>{post.addCommentPlaceholder}</div>
        </div>
      ))}
    </>
  );
};

export default Post;
